exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.feedback-button {\n    position: fixed;\n    height: 197px;\n    width: 35px;\n    right: 0;\n    top: 190px;\n    background: url('/img/feedback-right.png') no-repeat;\n    z-index: 9002;\n}\n", ""]);

// exports
